import { Location } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { Params, Router } from "@angular/router";
import { AuthService } from "src/app/core/service/auth.service";
import { UrlService } from "src/app/core/service/url.service";

@Component({
    selector: "app-back-button",
    templateUrl: "./back-button.component.html",
    styleUrls: ["./back-button.component.scss"],
    standalone: true,
    imports: [MatButtonModule, MatIconModule]
})
export class BackButtonComponent implements OnInit {
    @Input("color")
    public color: "primary" | "secondary" = "primary";

    @Input("route")
    private route: any[];

    @Input("logout")
    public logout: boolean;

    @Input("previous-location")
    private previousLocation: boolean;

    @Input("queryParams")
    queryParams: Params;

    private previousUrl: string;

    constructor(
        private location: Location,
        private router: Router,
        private authService: AuthService,
        private urlService: UrlService
    ) { }

    ngOnInit(): void {
        this.urlService.previousUrl$.subscribe((res) => (this.previousUrl = res));
    }

    backClicked(): void {
        const returnUrl = this.getReturnUrl();

        if (returnUrl) {
            window.location.href = returnUrl;
            return;
        }

        if (this.previousLocation && this.previousUrl) {
            this.location.back();
            return;
        }

        if (this.logout) {
            this.authService.logout().subscribe(() => {
                this.location.back();
            });
            return;
        }

        if (this.route && this.route.length > 0) {
            this.router.navigate(this.route, { queryParams: this.queryParams });
            return;
        }

        this.router.navigateByUrl("/app/");
    }

    private getReturnUrl(): string {
        const returnUrl = this.router.parseUrl(this.router.url).queryParams["returnUrl"];

        if (!returnUrl) return null;

        try {
            return new URL(returnUrl, location.origin).origin === location.origin ? returnUrl : null;
        } catch {
            return null;
        }
    }
}
